import moment from 'moment'
import formButton from '@/components/common/form-button/form-button.vue'
import labelBig from '@/components/common/label-big/label-big.vue'
import modal from '@/components/common/modal/modal.vue'
import { mapState, mapActions, mapGetters } from 'vuex'
import { find } from 'lodash'
import { formatDate } from '@/helpers/date'

export default {
  components: {
    formButton,
    labelBig,
    modal
  },
  data() {
    return {
      templateRes: {},
      closeButton: true
    }
  },
  props: {
    templateId: {
      type: Number,
      default: null
    }
  },
  computed: {
    ...mapState('competitionMechanic', ['mechanicList']),
    ...mapState('template', ['currentTemplate']),
    ...mapGetters('user', ['userById']),
    formatedDate() {
      return moment(this.currentTemplate.created_at).format('DD.MM.YYYY')
    },
    templateUsers() {
      return this.currentTemplate.usedBy
    },
    currentTemplateMechanicName: function () {
      let foundMechanic = find(this.mechanicList, (mechanic) => mechanic.id === this.currentTemplate.mechanic_id)
      return foundMechanic ? foundMechanic.name : ''
    }
  },
  methods: {
    ...mapActions('popup', ['setCurrentPopup']),
    ...mapActions('template', ['setCurrentTemplate']),
    ...mapActions('app', ['redirectTo']),
    useTemplate: function () {
      this.setCurrentPopup(null)
      this.redirectTo('create-competition')
    },
    formatDate
  },
  async created() {
    try {
      await this.setCurrentTemplate({ id: this.templateId })
    } catch (e) {
      throw e.response
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/pages/page-templates/templateModal/templateModal.js